/**
 *
 * AsyncPicker
 *
 */
import { Entity } from 'types/common';
import { FieldHookConfig, useField } from 'formik';
import { IFieldProps } from './FormRender/IFormFieldSetting';
import {
  IWorkOrderTypeStatusParamsPicker,
  WorkOrderTypeStatusPicker,
} from '../pickers/AutocompletePickers/WorkOrderTypeStatusPicker';

export const FormWorkOrderTypeStatusPicker = ({
  label,
  ...props
}: FieldHookConfig<Entity<number> | null> &
  IFieldProps &
  IWorkOrderTypeStatusParamsPicker) => {
  const [field, meta, helpers] = useField<Entity<number> | null>(props);
  return (
    <>
      <WorkOrderTypeStatusPicker
        typeId={props.typeId}
        onlyNew={props.onlyNew}
        info={props.info}
        name={props.name}
        variant="filled"
        placeholder={props.placeholder}
        label={label}
        onChange={value => {
          helpers.setValue(value, true);
          if (props.onChange) {
            props.onChange(value);
          }
        }}
        onBlur={field?.onBlur}
        value={field.value}
        error={meta?.error !== undefined}
        helperText={meta.error}
        fullWidth={props.fullWidth}
        disabled={props.disabled}
      />
    </>
  );
};
